// extracted by mini-css-extract-plugin
export default {"container":"SignInPage_container__OCRDe","title":"SignInPage_title__kkHkd","mfaDescription":"SignInPage_mfaDescription__A--+F"};